import { motion } from "framer-motion";
import { ArrowRight, GitCompare, RefreshCw, TrendingDown } from "lucide-react";

export function USPSection() {
  const scrollToContact = () => {
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
  };

  const features = [
    {
      icon: GitCompare,
      title: "Compare Vendors",
      desc: "Get transparent side-by-side comparisons so you always pick the best fit for your business.",
      color: "#6366f1",
    },
    {
      icon: RefreshCw,
      title: "Switch with Ease",
      desc: "Our team handles the full transition — zero disruption, zero paperwork headaches.",
      color: "#10b981",
    },
    {
      icon: TrendingDown,
      title: "Save Cost & Quality",
      desc: "Reduce expenses by up to 30% while improving service quality across all verticals.",
      color: "#f59e0b",
    },
  ];

  return (
    <section data-testid="usp-section" className="py-14 md:py-18 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-14"
        >
          <span className="text-red-600 font-bold text-xs tracking-[0.2em] uppercase font-body">
            The Smart Way
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-[44px] font-black mt-3 mb-3 tracking-tight">
            Compare. Choose. Switch.
          </h2>
          <p className="text-slate-500 text-base md:text-lg font-body max-w-lg mx-auto">
            A better approach to vendor management for modern businesses.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {features.map((feat, i) => {
            const Icon = feat.icon;
            return (
              <motion.div
                key={feat.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                className="bg-slate-50 rounded-3xl p-8 border border-slate-100 hover:-translate-y-1 hover:shadow-lg transition-all duration-300"
              >
                <div
                  className="w-14 h-14 rounded-2xl flex items-center justify-center mb-5"
                  style={{ background: `${feat.color}12` }}
                >
                  <Icon size={26} style={{ color: feat.color }} />
                </div>
                <h3 className="text-lg font-extrabold text-slate-900 mb-2 font-body">{feat.title}</h3>
                <p className="text-sm text-slate-500 leading-relaxed font-body">{feat.desc}</p>
              </motion.div>
            );
          })}
        </div>

        <div className="text-center">
          <button
            data-testid="usp-get-vendor-btn"
            onClick={scrollToContact}
            className="bg-gradient-to-r from-red-600 to-red-700 text-white font-extrabold text-[15px] px-8 py-4 rounded-2xl shadow-xl shadow-red-600/25 hover:shadow-red-600/35 transition-all active:scale-95 inline-flex items-center gap-2 font-body"
          >
            Get Best Vendor Now <ArrowRight size={18} />
          </button>
        </div>
      </div>
    </section>
  );
}
